import { createSlice } from "@reduxjs/toolkit";

const pageLayoutSlice = createSlice({
  name: "pageLayout",
  initialState: {
    //initial state of action bar: if it is sticky to header or not
    actionBar: { sticky: false },
    //initial state of full screen mode
    fullScreen: false,
    //initial state of auto save bar
    autoSaveBar: {
      savedAt: null,
      lastPublishedAt: null,
      saving: false,
      publishing: false,
      reverting: false,
    },
  },
  reducers: {
    setActionBarSticky(state, action) {
      state.actionBar.sticky = action.payload;
    },
    setFullScreen(state, action) {
      state.fullScreen = action.payload;
    },
    setAutoSaveBar(state, action) {
      //used check of undefined because we may want to update only one of the properties
      //in this case we keep the other as is
      state.autoSaveBar.savedAt =
        action.payload.savedAt === undefined
          ? state.autoSaveBar.savedAt
          : action.payload.savedAt;

      state.autoSaveBar.lastPublishedAt =
        action.payload.lastPublishedAt === undefined
          ? state.autoSaveBar.lastPublishedAt
          : action.payload.lastPublishedAt;

      state.autoSaveBar.saving =
        action.payload.saving === undefined
          ? state.autoSaveBar.saving
          : action.payload.saving;

      state.autoSaveBar.publishing =
        action.payload.publishing === undefined
          ? state.autoSaveBar.publishing
          : action.payload.publishing;

      state.autoSaveBar.reverting =
        action.payload.reverting === undefined
          ? state.autoSaveBar.reverting
          : action.payload.reverting;
    },
  },
});

export const { setActionBarSticky, setFullScreen, setAutoSaveBar } =
  pageLayoutSlice.actions;
export default pageLayoutSlice.reducer;
